module.exports = __webpack_public_path__ + "static/img/stem_innovator_logo_trans.ce7c6584.png";